import * as React from 'react'
import Dropzone from 'react-dropzone'
import CX from 'classnames'
import { NonIdealState } from '@blueprintjs/core'
import { IconNames } from '@blueprintjs/icons'

interface DroppableRegionProps {
  imageCount: number
  maxImages: number
  onDrop: any
  isDisabled?: boolean
  className?: string
  children?: React.ReactNode
}

const resetStyle = {}
export const DroppableImageRegion: React.FC<DroppableRegionProps> = ({
  imageCount,
  maxImages,
  onDrop,
  isDisabled = false,
  className = 'dropzone dropzone-dashed-border',
  children
}) => {
  const maxImagesReached = imageCount >= maxImages
  return (
    <Dropzone
      disabled={maxImagesReached || isDisabled}
      accept="image/jpeg, image/png"
      onDrop={onDrop}
      className={CX(className, { disabled: maxImagesReached || isDisabled })}
      style={resetStyle}
      data-testid="image-dropzone"
      title="Drag and drop or click to add images"
    >
      {children || (
        <NonIdealState
          description={(() => {
            if (maxImagesReached) return `No more than ${maxImages} images are allowed`

            return 'Drag and drop or click to add images'
          })()}
          icon={maxImagesReached || isDisabled ? IconNames.DISABLE : IconNames.PLUS}
        />
      )}
    </Dropzone>
  )
}
